import { Slider } from "@mui/material";
import { styled } from "@mui/system";

export const CustomSlider = styled(Slider)`
  & .MuiSlider-rail {
    background: white;
    opacity: 0.8;
  }
`;
